<section class="wraper-sub">
  <div class="lead-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">My Closed Orders</h1>
        <div class="price-top-m">
          <p class="price-sub" data-toggle="modal" data-target="#year_selection">
            <span *ngIf="leads.totalPay">$ {{ leads.totalPay | number }}</span>
            <span *ngIf="!leads.totalPay">$ 0</span>
            <i class="fa fa-caret-down" aria-hidden="true" *ngIf="leads.totalPay"></i>
          </p>

          <div class="year-selection-m sales-selection-m" *ngIf="leads.totalPay">
            <!-- Modal -->
            <div class="modal fade" id="year_selection" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Total : $ {{ leads.totalPay | number }}</h5>
                </div>
                <div class="modal-content">
                  <div class="modal-body">
                    <ul class="year-selection-p sales-Stats-m">
                      <!-- <li>
                        <label>Total Closed</label>
                        <span>$ {{ leads.totalPay | number: '3.1-5' }}</span>
                      </li> -->

                      <ng-container *ngFor="let item of leads.totalValidParts">
                        <li *ngIf="item.valid_sales != 2">
                          <label>Total {{ item.valid_sales == 0 ? 'Invalid' : 'Valid' }}</label>
                          <span *ngIf="item.totpay">$ {{ item.totpay | number }}</span>
                          <span *ngIf="!item.totpay">$ 0</span>
                        </li>
                      </ng-container>

                      <ng-container *ngFor="let item of leads.totalVerifiedParts">
                        <li *ngIf="item.verified_sales != 2">
                          <label>Total {{ item.verified_sales == 0 ? 'Unverified' : 'Verified' }}</label>
                          <span *ngIf="item.totpay">$ {{ item.totpay | number }}</span>
                          <span *ngIf="!item.totpay">$ 0</span>
                        </li>
                      </ng-container>

                      <li class="overall-rating">
                        <label>Overall Rating:{{ leads.overallRatingComplete }}</label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m largeField">
              <input type="text" name="search" [(ngModel)]="searchParams.emailId" (change)="rerender()" placeholder="Search by Order ID, Email or Phone">
              <i class="fa fa-search" aria-hidden="true" (change)="rerender()"></i>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m date-filter">
              <input (onHidden)="splitFromTo()" [(ngModel)]="fullRangeDate" type="text" placeholder="Date Range" bsDaterangepicker [bsConfig]="{ isAnimated: true, showWeekNumbers: false}">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z"
                  fill="#1C212D" />
                <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#1C212D" />
                <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#1C212D" />
                <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#1C212D" />
                <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#1C212D" />
                <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#1C212D" />
                <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#1C212D" />
                <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#1C212D" />
                <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#1C212D" />
                <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#1C212D" />
                <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#1C212D" />
                <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#1C212D" />
                <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#1C212D" />
                <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#1C212D" />
                <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#1C212D" />
              </svg>
            </div>
          </div>

          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                  [items]="validInvalidArr"
                  bindLabel="name"
                  bindValue="value"
                  placeholder="Select Valid/Invalid"
                  [(ngModel)]="searchParams.valid_sales"
                  [ngModelOptions]="{standalone: true}"
                  [searchable]="false"
                  [clearable]="true"
                  (change)="rerender()">
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                  [items]="veriUnveriArr"
                  bindLabel="name"
                  bindValue="value"
                  placeholder="Select Verified/Unverified"
                  [(ngModel)]="searchParams.verified_sales"
                  [ngModelOptions]="{standalone: true}"
                  [searchable]="false"
                  [clearable]="true"
                  (change)="rerender()">
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>

          <!-- Order Type -->
          <!-- <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                  [items]="orderTypesArray"
                  bindLabel="name"
                  bindValue="value"
                  placeholder="Order Type"
                  [(ngModel)]="searchParams.order_type"
                  [ngModelOptions]="{standalone: true}"
                  [searchable]="false"
                  [clearable]="false"
                  (change)="rerender()">
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div> -->

          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z"
                  fill="#1C212D" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Timestamp</th>
              <th>Client info</th>
              <th>Price / No. of Pages</th>
              <th>Academic Level</th>
              <th>Document Type</th>
              <th>Due Date</th>
              <th>Status</th>
              <th>Feedback</th>
              <th>Agent Comments</th>
            </tr>
          </thead>
          <ng-container *ngIf="leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td>
                  <a class="id" href="javascript:;" routerLink="/order-detail/{{ lead.id | base64 }}" target="_blank">
                    {{ lead.order_id }}
                  </a>
                </td>
                <td>
                  <ng-container *ngIf="lead.date && lead.date != '0000-00-00 00:00:00'">
                    <p class="time-done">{{ lead.date | date }}</p>
                    <p class="time-done">{{ lead.date | date:'shortTime' }}</p>
                  </ng-container>
                </td>

                <td>
                  <p>{{ lead.name | capitalize }}</p>
                  <p>{{ lead.phone }}</p>
                  <p>{{ lead.email }}</p>
                </td>

                <td>
                  <p class="price-td" [ngClass]="{'fullpay': !lead.half_price, 'halfpay': lead.half_price}">$ {{ lead.amount }}</p>
                  <p class="page-td">{{ lead.pages }} Pages</p>
                </td>

                <td><p>{{ lead.level | capitalize }}</p></td>
                <td>
                  <p class="time-done">{{ lead.work_type | capitalize }}</p>
                </td>

                <td>
                  <p *ngIf="!lead.delivery_date">-</p>
                  <ng-container *ngIf="lead.delivery_date">
                    <p class="time-done">{{ lead.delivery_date | date }}</p>
                    <p class="time-done">{{ lead.delivery_date | date:'shortTime' }}</p>
                  </ng-container>
                  <p [ngClass]="{'time-elapsed': lead.invert, 'time-left': !lead.invert}" *ngIf="lead.time_remaining">{{ lead.time_remaining }}</p>
                </td>

                <td>
                  <p class="roundedShape">
                    <span [ngClass]="{'disabledBox': !lead.valid_sale_check, 'validBox': lead.valid_sale_check}">
                        <ng-container>{{ lead.valid_sale_text }}</ng-container>
                    </span>
                  </p>
                </td>

                <td>
                  <div class="pos-rel" *ngIf="lead.showRateCol">
                    <a href="javascript:;" (click)="showComments(lead, indx, 'QA-Comments')" *ngIf="!lead.loadingQACom">
                      <div class="stars genralFeedback">
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.rating) >= 1 , 'active-half': parseFloat(lead.rating) > 0 && parseFloat(lead.rating) < 1 }"></i>
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.rating) >= 2 , 'active-half': parseFloat(lead.rating) > 1 && parseFloat(lead.rating) < 2 }"></i>
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.rating) >= 3 , 'active-half': parseFloat(lead.rating) > 2 && parseFloat(lead.rating) < 3 }"></i>
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.rating) >= 4 , 'active-half': parseFloat(lead.rating) > 3 && parseFloat(lead.rating) < 4}"></i>
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.rating) >= 5 , 'active-half': parseFloat(lead.rating) > 4 && parseFloat(lead.rating) < 5}"></i>
                      </div>
                    </a>

                    <!-- Action Loader -->
                    <i class="fa fa-spinner fa-spin qaLoaderIcon" aria-hidden="true" *ngIf="lead.loadingQACom"></i>

                    <!-- QA Feedback Modal -->
                    <div class="qa-feedback-m">
                      <div class="modal fade" [id]="'qaFeedBack_modal'+indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel2">Q/A Feedback</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body" *ngIf="qaComments.length > 0">
                              <ng-container *ngFor="let comment of qaComments">
                                <div class="feedback-madal comment-box">
                                  <div class="ratings" *ngIf="comment.qaRating">
                                    <div class="stars">
                                      <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 1 , 'active-half': comment.qaRating > 0 && comment.qaRating < 1 }"></i>
                                      <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 2 , 'active-half': comment.qaRating > 1 && comment.qaRating < 2 }"></i>
                                      <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 3 , 'active-half': comment.qaRating > 2 && comment.qaRating < 3 }"></i>
                                      <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 4 , 'active-half': comment.qaRating > 3 && comment.qaRating < 4}"></i>
                                      <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 5 , 'active-half': comment.qaRating > 4 && comment.qaRating < 5}"></i>
                                    </div>
                                    <span class="rating-points">{{ comment.qaRating }}/5</span>
                                  </div>

                                  <p class="comment-txt" [innerHtml]="comment.notes | safeHtml:'html' "></p>
                                  <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                                  <p class="qa-name">{{ agentSearch(comment.user_id, qa) }}</p>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <td>
                  <div class="pos-rel">
                    <a href="javascript:;" (click)="showComments(lead, indx, 'Closed-Agent-Comments')" *ngIf="!lead.loadingComs">
                      <svg width="29" height="27" viewBox="0 0 29 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.64618 7.36366H19.9379C20.2718 7.36366 20.542 7.08919 20.542 6.75001C20.542 6.41082 20.2718 6.13635 19.9379 6.13635H6.64618C6.31222 6.13635 6.04199 6.41082 6.04199 6.75001C6.04205 7.08925 6.31228 7.36366 6.64618 7.36366Z"
                          [attr.fill]="lead.showComments ? '#00A5DC' : 'grey'" />
                        <path d="M13.8962 13.5H6.64618C6.31222 13.5 6.04199 13.7745 6.04199 14.1137C6.04199 14.4528 6.31222 14.7273 6.64618 14.7273H13.8962C14.2301 14.7273 14.5004 14.4528 14.5004 14.1137C14.5004 13.7745 14.2301 13.5 13.8962 13.5Z"
                          [attr.fill]="lead.showComments ? '#00A5DC' : 'grey'" />
                        <path
                          d="M26.6872 2.45456C26.6522 2.45456 26.6183 2.46348 26.5834 2.46515V2.45456C26.5834 1.10086 25.4989 0 24.1667 0H2.41669C1.08444 0 0 1.10086 0 2.45456V26.3863C0 26.6345 0.147492 26.8585 0.372865 26.9532C0.447234 26.985 0.526248 27 0.604129 27C0.76108 27 0.915652 26.9377 1.03131 26.8202L6.896 20.8636H24.1667C25.4989 20.8636 26.5834 19.7628 26.5834 18.4091V8.23104L28.3227 6.46475C28.3227 6.46475 28.3227 6.46475 28.3227 6.46417C28.7534 6.02673 29 5.42147 29 4.80362C29 3.50808 27.9628 2.45456 26.6872 2.45456ZM25.375 18.4091C25.375 19.0856 24.8333 19.6363 24.1667 19.6363H6.64581C6.48535 19.6363 6.33191 19.701 6.21863 19.8161L1.20831 24.905V2.45456C1.20831 1.77803 1.74997 1.22731 2.41663 1.22731H24.1666C24.8334 1.22731 25.375 1.77803 25.375 2.45456V2.87371C25.2603 2.95379 25.1506 3.04187 25.0517 3.14248L18.478 9.81819H6.64581C6.31186 9.81819 6.04163 10.0927 6.04163 10.4318C6.04163 10.771 6.31186 11.0455 6.64581 11.0455H17.5086L16.9285 13.9932C16.8884 14.1946 16.9509 14.4026 17.0937 14.5475C17.2082 14.6638 17.3627 14.7273 17.5209 14.7273C17.5598 14.7273 17.5999 14.7231 17.6389 14.7153L20.6585 14.1017C20.7765 14.0777 20.8839 14.0196 20.9677 13.9339L25.375 9.45817V18.4091ZM20.2431 12.9349L18.2914 13.3316L18.682 11.3469L24.1664 5.77653L25.7289 7.36357L20.2431 12.9349ZM27.4683 5.59705L26.5833 6.49593L25.0207 4.90878L25.9059 4.00961C26.1113 3.80164 26.3957 3.68181 26.6871 3.68181C27.296 3.68181 27.7916 4.18519 27.7916 4.80362C27.7917 5.09845 27.6736 5.38793 27.4683 5.59705Z"
                          [attr.fill]="lead.showComments ? '#00A5DC' : 'grey'" />
                      </svg>
                    </a>

                    <!-- Action Loader -->
                    <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="lead.loadingComs"></i>

                    <!-- Comments Modal -->
                    <div class="notesModal mainModal qa-lead text-left">
                      <div class="modal fade" [id]="'comment_modal'+indx" tabindex="-1" role="dialog" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title text-left">Agent Comments</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <form [formGroup]="addCommentForm">
                                <div class="formItem shadowed w-100">
                                  <textarea [(ngModel)]="notes" formControlName="comment" [ngClass]="{ 'is-invalid': submitted && f.comment.errors }" placeholder="Add a new comment by typing here."></textarea>
                                </div>
                                <div class="formBtns text-right">
                                  <button class="pBtn" (click)="addNotes(lead, indx)">Add
                                    <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="loading"></i>
                                  </button>
                                </div>
                              </form>
                              <h5 class="modal-title text-left" *ngIf="agentComments && agentComments.length > 0">All Previous Comments</h5>
                              <ul class="allNotes" [ngClass]="{'fixHeight': (agentComments && agentComments.length > 3)}" *ngIf="agentComments">
                                <li *ngFor="let comment of agentComments">{{ comment.notes }}</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </ng-container>

        </table>
      </div>
    </div>

  </div>
</section>
